module.exports = __webpack_public_path__ + "images/bubbles_right.png";